import React, {Component
}   from 'react';
import PropTypes          from 'prop-types';
import { appConfig } from '../../../config/appConfig';
import {
  Row,
  Col,
  Checkbox,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  
  Alert
}                     from 'react-bootstrap';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import { createBrowserHistory } from 'history';

import moment from 'moment';
import '../dashboard/dashboard.scss';
import CountryStateCity from '../../../components/countryStateCity/CountryStateCity';
import { partnerPermission, register, getcharityList, getSiteCity } from '../../../redux/actions/frontActions';
import logo from '../../../img/ddb-logo.png';

import { Notification } from '../../../components/notifications';

import {renderAlert, clearAlert} from '../../../redux/actions/alertsActions';
import NumberFormat from 'react-number-format';
import Cookies from 'universal-cookie';
import DatePicker from 'react-date-picker';
import ReactAutocomplete from 'react-autocomplete';
import languageConfig from '../../../config/languageConfig';
import Recaptcha from 'react-recaptcha';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import PasswordStrengthBar from 'react-password-strength-bar';
import PasswordChecklist from "react-password-checklist"


const cookies = new Cookies();

const history = createBrowserHistory();
let xCoordinate = {}, yCoordinate = {};
let isLoading = 'false';
class Register extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      firstName: '',
      lastName: '',
      phone:'',
      gender:'Male',
      dob:'',
      address1:'',
      address2:'',
      country:'',
      state:'',
      city:'',
      cityID:'',
      addCity: '',
      cemail:'',
      email:'',
      password:'',
      cpassword:'',
      zipcode:'',
      stateAbbr:'',
      username:'',
      countryerror:'false',
      stateerror:'false',
      cityerror:'false',
      affiliated_by: '',
      showAlert: false,
      term_condition: true,
      countryName:'United States',
      disabled:'',
      enabled: '',
      required: '',
      hover: false,
      charity: '',
      charity_id: '',
      disabled: false,
      cityList: [],
      charity_name: '',
      multi_lang: 'no',
      lang: '',
      default_lang: 'en',
      //default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en'),
      default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en')
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
    this.expiredCallback = this.expiredCallback.bind(this);
    this.onloadCallback = this.onloadCallback.bind(this);
    this.handleTermConditionChange = this.handleTermConditionChange.bind(this);
    this.Clear=this.Clear.bind(this);
  }

  onChangeStartDate = (selectedDate) => {
   
    if (selectedDate instanceof Date && !isNaN(selectedDate)) {
         this.setState({
           dob: selectedDate,
           dobError: false // Reset error state if a valid date is selected
         });
       } 
       else if(selectedDate  === null)
       {
        this.setState({
          dob: '',
          dobError: false // Reset error state if a valid date is selected
        });
       }
       else {
         // Handle invalid date (optional)
       //  console.error('Invalid date selected:', selectedDate);
      
         this.setState({
      
        dobError: true // Set error state to indicate invalid date
           
         });
    
       }
     };
    
  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem('data-id').value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem('data-id').value });    
  }

  handleChange = (e) => {
    this.setState({[e.target.name] : e.target.value});

    if(`${e.target.name}Error` !== '') {
      this.setState({[`${e.target.name}Error`]:''});
    }
    this.setState({ disabled: false });
  }

  handleDismiss() {
    this.setState({ showAlert: false });
  }

  handleShow() {
    this.setState({ showAlert: true });
  }

   setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    siteData.default_lang = lang; 
    localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
    this.setState({
        default_lang: lang
    });
    
    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });

    this.props.setLanguage(lang);
    this.props.getSiteStatus(lang); 
    this.props.getMenuList({page:1, lang: lang, cityID: siteData.default_city});
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: lang});
    }
  }

  handlePageChange = page => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){ 
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
        });
      }
    }

    this.setState({
      currentPage: page,
      cartTotal: 0
    });
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
    }
  };


  Clear() {
    this.setState({
      firstName: '',
      lastName: '',
      phone:'',
      gender:'Male',
      dob:'',
      address1:'',
      address2:'',
      cemail:'',
      email:'',
      password:'',
      cpassword:'',
      zipcode:'',
      username:'',
      countryName:'United States',
      enabled: '',
      required: '',
      charity: '',
      charity_id: '',
      charityOption: 'disable',
      country: '',
      state: '',
      cityID: '',
      addCityID: '',
      default_lang: 'en'
    });
  }

    componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let disableSubscriptionPopup = (localStorage.getItem('disableSubscriptionPopup')) ? localStorage.getItem('disableSubscriptionPopup') : false;
    let accessibleCities = (localStorage.getItem('accessibleCities')) ? JSON.parse(localStorage.getItem('accessibleCities')) : [];

    // alert("Footer default_lang"+siteData.default_lang);
    // alert("Footer multi_lang"+siteData.multi_lang);
    // alert("Footer lang"+siteData.lang);

    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
  
        });
      }
    }

    if(siteData){
      this.setState({ fontFamilies: siteData.font_families });
    }

    if(siteData){
      this.setState({twitterPage: siteData.twitterPage,facebookPage: siteData.facebookPage, siteName: siteData.siteName, youtube_link: siteData.youtube_link, insta_link: siteData.insta_link});
      let showCityPasswordFrom = true 
      if(siteData.password_protect == 'active' && this.props.match.path != '/login' && this.props.match.path != '/register/') {
        const cityPasswordIndx = siteData.city_passwords.findIndex(x => x.cityID === siteData.default_city);
        const cityIndx = accessibleCities.findIndex(x => x.cityID === siteData.default_city);
        
        if((cityIndx >= 0 && accessibleCities[cityIndx].status == true) || cityPasswordIndx == -1 ) {
          showCityPasswordFrom = false;
        }
        this.setState({ showCityPasswordFrom: showCityPasswordFrom });
      }
          
    }

    if(this.props.themeData){
      this.setState({
        themeData: this.props.themeData
      });

      if(this.props.themeData.menu_bar){
        this.setState({
          menuBgStyles: {
            backgroundColor: this.props.themeData.menu_bar.menu_bar_color
          }
        })
      }else{
        this.setState({
          menuBgStyles: {
            backgroundColor: ''
          }
        })
      }
      if(this.props.themeData.footer){
        this.setState({
          footerBgStyles: {
            'backgroundColor': this.props.themeData.footer.footer_color,
          },
          footerTextStyles: {
            'color': this.props.themeData.footer.footer_text_color,
          },
          footer_social_link_color: {
            'color' : this.props.themeData.footer.footer_social_link_color,
          }
          
        });
      }else{
        this.setState({
          footerBgStyles: {
            'backgroundColor': '',
          },
          footerTextStyles: {
            'color': '',
          },
          footer_social_link_color: {
            'color' : '',
          }
          
        });
      }

      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }else{
        this.setState({
          button_color: '',
          mouseover_color: '',
        });
      }

    }
  }

  componentWillMount() {
    if(this.props.themeData) {
      if(this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color
        });
      }
    }
    isLoading = 'true';
    this.props.partnerPermission('registration-form/fields');
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    this.props.getcharityList({'assigned_city_ids': siteData.default_city ? siteData.default_city : ''}); 
    if(siteData) {
      this.setState({siteName: siteData.siteName, charityOption: siteData.charity, multi_lang: siteData.multi_lang, lang: siteData.lang, default_lang: siteData.default_lang, siteKey:siteData.siteKey, assigned_city_ids: siteData.default_city});
    }
    
    this.props.getSiteCity();
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.language) {
      this.setState({default_lang: nextProps.language});
    }
    if(nextProps.themeData) {
      if(nextProps.themeData.button) {
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color
        });
      }
    }
    if(this.props.permission !== nextProps.permission) {
      if(nextProps.permission) {
        if(nextProps.permission.data) {
          this.setState({
            enabled: nextProps.permission.data.enabled,
            required: nextProps.permission.data.required
          });
        }
        isLoading = 'false';
      }
    }
    if(this.props.getCharity !== nextProps.getCharity) {
      if(nextProps.getCharity) {
        this.setState({charity: nextProps.getCharity});
      }
    }
    if(this.props.regStatus != nextProps.regStatus) {
      if(nextProps.regStatus) {
        this.setState({showAlert:true});
        this.props.renderAlert('success', 'User account has been created successfully.');
        this.Clear();
        window.scrollTo(0, 0);
        this.props.partnerPermission('registration-form/fields');
        let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
        if(siteData) {
          this.setState({siteName: siteData.siteName, charityOption: siteData.charity});
        }
        // this.props.getcharityList();
      }
    }

    if(this.props.error != nextProps.error) {
      if(nextProps.error) {
        this.setState({showAlert:true});
        this.handleShow();
        this.props.renderAlert('warning', nextProps.error);
        window.scrollTo(0, 0);
        let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
        if(siteData) {
          this.setState({siteName: siteData.siteName, charityOption: siteData.charity});
        }
        this.props.partnerPermission('registration-form/fields');
        // this.props.getcharityList();
      }
    }

    if(this.props.message !== nextProps.message) {
      this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType});
      // Clear();
    }

    if(this.props.cityList != nextProps.cityList) {
      if(nextProps.cityList) {
        this.setState({cityList: nextProps.cityList.data});
      }
    }
  }

  componentWillUpdate(nextProps, nextState) {
  }

  validate = () => { 
    let isError = false;
    let errMessage = "";
    xCoordinate = {};
    yCoordinate = {};

    if(!this.state.firstName && this.state.required.firstName == '0') {
      isError = true;
      this.setState({firstNameError:'red'});
    }

    if(!this.state.lastName && this.state.required.lastName == '0') {
      isError = true;
      this.setState({lastNameError:'red'});
    }

    if(!this.state.gender && this.state.required.gender == '0') {
      isError = true;
      this.setState({genderError:'red'});
    }

    if(!this.state.address1 && this.state.required.address1 == '0') {
      isError = true;
      this.setState({address1Error:'red'});
    }

    if(!this.state.address2 && this.state.required.address2 == '0') {
      isError = true;
      this.setState({address2Error:'red'});
    }

    if(!this.state.username && this.state.required.userName == '0') {
      isError = true;
      this.setState({usernameError:'red'});
    }

    if(!this.state.country  && this.state.required.country == '0') {
      isError = true;
      this.setState({countryError:'red'});
    }
   
    if(!this.state.state && this.state.required.state == '0') {
      isError = true;
      this.setState({stateError:'red'});
    }
    
    if(!this.state.addCity && this.state.required.addCity == '0') {
      isError = true;
      this.setState({addCityError:'red'});
    }

    if(!this.state.cityID && this.state.required.city == '0') {
      isError = true;
      this.setState({cityIDError:'red'});
    }

    if(!this.state.email  && this.state.required.email == '0') {
      isError = true;
      this.setState({emailError:'red'});
    }else if(this.state.email) {
      if(this.getValidationEmailState()) {
        isError = true;
        this.setState({emailError:'red'});
      }
    }

    if(!this.state.cemail && this.state.required.confirm_email == '0') {
      isError = true;
      this.setState({cemailError:'red'});
    } else if(this.state.cemail) {
      if(this.getValidationEmailState2()) {
        isError = true;
        this.setState({cemailError:'red'});
      }
    }
    
    if(this.state.email && this.state.cemail && this.state.email != this.state.cemail) {
      isError = true;
      this.setState({cemailError:'red'});
    }

    if(!this.state.password  && this.state.required.password == '0') {
      isError = true;
      this.setState({passwordError:'red'});
    }

    if(!this.state.cpassword  && this.state.required.cpassword == '0') {
      isError = true;
      this.setState({cpasswordError:'red'});
    }

    if((this.state.password != this.state.cpassword) && (this.state.required.password == '0'  && this.state.required.confirm_password == '0')) {
      isError = true;
      this.setState({cpasswordError:'red'});
    }

    if(!this.state.phone && this.state.required.phone == '0') {
      isError = true;
      this.setState({phoneError:'red'});
    }

    if(!this.state.zipcode && this.state.required.zipCode == '0') {
      isError = true;
      this.setState({zipcodeError:'red'});
    }

    if(!this.state.dob && this.state.required.dob == '0') {
      isError = true;
      this.setState({dobError:'red'});
    }

    if(!this.state.term_condition) {
      isError = true;
      errMessage = 'Please accept Terms of Use and Privacy Policy condition.';
    }

    if(!this.state.isVerified && !(this.state.siteKey && (this.state.siteKey=='qW9hV53Wl6RgpfJzDM95HiFlp5YC6EJt5+klJrhgaEk=' || this.state.siteKey=='hEhNweI8U4TkdzJsZDU5JljMbQRZqbDbNnDM46hEBxE='))) {
      isError = true;
      errMessage = 'Please verify that you are human.';
    }
    
    if(isError && errMessage != "") {
      this.setState({showAlert: true});
      this.props.renderAlert('Error', errMessage);

      let x = window.scrollX + document.querySelector('#panelBodyMsg').getBoundingClientRect().left
      let y = window.scrollY + document.querySelector('#panelBodyMsg').getBoundingClientRect().top - 89
      xCoordinate['panelBodyMsg'] = x;
      yCoordinate['panelBodyMsg'] = y;
    }

    return isError;
  }

  handleTermConditionChange(e) {
    this.setState({term_condition:e.target.checked});
  }

  getValidationEmailState() {
    if(this.state.email) {
      const length = this.state.email.length;
      if(length !==0) {
        let emailpattern= new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        if(!emailpattern.test(this.state.email)) {
          return 'error';
        }
      }
    }
    
    return null;
  }

  getValidationEmailState2() {
    if(this.state.cemail) {
      const length = this.state.cemail.length;
      if(length !==0) {
        let emailpattern= new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        if(!emailpattern.test(this.state.cemail)) {
          return 'error';
        }
      }
    }
    
    return null;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const err = this.validate();
    let affiliateID = [];
    affiliateID=cookies.get('affiliateID');
    let affiliated_by='';
    if (typeof affiliateID !== 'undefined') {
      affiliated_by= affiliateID.affiliateID;
    }

    if(!err) {
      this.setState({disabled:true});
      let formData = {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        phone:this.state.phone,
        gender:this.state.gender,
        //dob: new Date(),
        dob:moment(this.state.dob).format('YYYY-MM-DD'),
        address1:this.state.address1,
        address2:this.state.address2,
        country:this.state.country,
        state:this.state.state,
        addCity: this.state.addCity,
        city:this.state.city,
        cityID:this.state.cityID,
        email:this.state.email,
        password:this.state.password,
        zipcode:this.state.zipcode,
        stateAbbr:this.state.stateAbbr,
        userName:this.state.username,
        affiliated_by: affiliated_by,
        charity_id: this.state.charity_id,
        lang: this.state.default_lang
      };
      isLoading='true';
      this.props.register(formData);
    } else{
      let arr = Object.values(yCoordinate)
      let min = Math.min(...arr);
      let yCoordinateKey= '',yCoordinateValue, xCoordinateValue
      {Object.keys(yCoordinate).map((key) => {
        if(yCoordinate[key] === min && yCoordinateKey.length == 0){
          yCoordinateValue = yCoordinate[key]
          yCoordinateKey = key
        }
      })}
      if(yCoordinateKey.length > 0){
        xCoordinateValue = xCoordinate[yCoordinateKey]
      }
      window.scrollTo(xCoordinateValue, yCoordinateValue);
    }
  }

  getValidationState() {
    if(this.state.phone) {
      const length = this.state.phone.length;
      if(length !==0) {
        let mobilepattern= new RegExp(/^\d{3}-\d{3}-\d{4}$/i);
        if(!mobilepattern.test(this.state.phone)) {
          return 'error';
        }
      }
    }
    
    return null;
  }

  onChangeCharity = (e) => {
    this.setState({charity_name: e.target.value});
    this.props.getcharityList({limit: 10, search: e.target.value, assigned_city_ids: this.state.assigned_city_ids});
  }

  onloadCallback() {
    console.log('Recaptcha loaded successfully!');
  }
 
  verifyCallback = (res) => {
    if(res) {
      this.setState({
        isVerified: true
      });
    }
  };

  expiredCallback() {
    this.setState({
      isVerified: false
    });
  };

  render() {
    let reg_term = languageConfig[this.state.default_lang].i_agree_reg;
    let enabled = (this.state.enabled) ? this.state.enabled : '';
    let hidecapta = (this.state.siteKey && (this.state.siteKey=='qW9hV53Wl6RgpfJzDM95HiFlp5YC6EJt5+klJrhgaEk=' || this.state.siteKey=='hEhNweI8U4TkdzJsZDU5JljMbQRZqbDbNnDM46hEBxE='));
    return(
      <div> 
        {isLoading == 'true' ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ''
        )}
        <form onSubmit={this.handleSubmit}>            
          <div className="container">
                
            <div className="panel margin-top">
              <header className="panel-heading">{languageConfig[this.state.default_lang].personal_information}</header>
              <div className="panel-body">
                <div id="panelBodyMsg">
                  {this.state.showAlert && this.state.alertMessage !=='' &&        
                    <div className="col-lg-12">
                      <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                        <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                      </Alert>
                    </div>
                  }
                </div>
                <Row>
                  <Col md={8} xs={12}>
                    <Row>
                      {(enabled.firstName == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>{languageConfig[this.state.default_lang].first_name} <span style={{color:"red"}}>{this.state.required.firstName== '0' ? '*':''}</span></ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.firstName}
                                placeholder={languageConfig[this.state.default_lang].first_name}
                                onChange={this.handleChange}
                                style={{borderColor:this.state.firstNameError}}
                                name="firstName"
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                      }

                      {(enabled.lastName == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>{languageConfig[this.state.default_lang].last_name} <span style={{color:"red"}}>{this.state.required.lastName== '0' ? '*':''}</span></ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.lastName}
                                placeholder={languageConfig[this.state.default_lang].last_name}
                                onChange={this.handleChange}
                                style={{borderColor:this.state.lastNameError}}
                                name="lastName"
                                autoComplete="off"
                              />
                            </FormGroup>
                            
                          </Col>
                      }
                    </Row>
                    <Row>
                      {(enabled.phone == '0') &&
                          <Col md={6} xs={12}>
                            <ControlLabel >{languageConfig[this.state.default_lang].phone_no} ({languageConfig[this.state.default_lang].format}: xxx-xxx-xxxx) <span style={{color:"red"}}>{this.state.required.phone== '0' ? '*':''}</span></ControlLabel>
                            <FormGroup controlId="formBasicPhoneText" validationState={this.getValidationState()}>
                     <NumberFormat
                                format="###-###-####"
                                mask="_"
                                className="form-control"
                                name="phone"
                                placeholder={languageConfig[this.state.default_lang].phone_no}
                                value={this.state.phone}
                                onChange={this.handleChange}
                                autoComplete="off"
                                style={{ borderColor: this.state.phoneError }}
                    />  
                            </FormGroup>
                          </Col>
                      }
                      {(enabled.gender == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <FormGroup controlId="gender">
                                <ControlLabel>{languageConfig[this.state.default_lang].gender} <span style={{color:"red"}}>{this.state.required.gender== '0' ? '*':''}</span></ControlLabel>
                                <FormControl name="gender" style={{borderColor:this.state.genderError}} onChange={this.handleChange} value={this.state.gender} componentClass="select">
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                        
                                </FormControl>
                               
                              </FormGroup>
                            </FormGroup>
                          </Col>
                      }
                    </Row>
                    <Row>
                      {(enabled.dob == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>{languageConfig[this.state.default_lang].date_birth} <span style={{color:"red"}}>{this.state.required.dob== '0' ? '*':''}</span></ControlLabel><br/>
                              <DatePicker
                                onChange={this.onChangeStartDate}
                                value={this.state.dob}
                                className={(this.state.dobError) ? 'error' : ''}
                              />
                                
                            </FormGroup>
                          </Col>
                      }
                      {(enabled.address1 == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>{languageConfig[this.state.default_lang].address} <span style={{color:"red"}}>{this.state.required.address1== '0' ? '*':''}</span></ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.address1}
                                placeholder={languageConfig[this.state.default_lang].address}
                                onChange={this.handleChange}
                                style={{borderColor:this.state.address1Error}}
                                name="address1"
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                      }
                    </Row>
                    <Row>
                      {(enabled.address2 == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <FormGroup controlId="address2">
                                <ControlLabel>{languageConfig[this.state.default_lang].address2} <span style={{color:"red"}}>{this.state.required.address2== '0' ? '*':''}</span></ControlLabel>
                                <FormControl
                                  type="text"
                                  value={this.state.address2}
                                  placeholder={languageConfig[this.state.default_lang].address2}
                                  onChange={this.handleChange}
                                  style={{borderColor:this.state.address2Error}}
                                  name="address2"
                                  autoComplete="off"
                                />
                              </FormGroup>
                            </FormGroup>
                          </Col>
                      }
                      {(enabled.zipCode == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <FormGroup controlId="zip">
                                <ControlLabel>{languageConfig[this.state.default_lang].zip_code} <span style={{color:"red"}}>{this.state.required.zipCode== '0' ? '*':''}</span></ControlLabel>
                                <FormControl
                                  type="text"
                                  value={this.state.zipcode}
                                  placeholder={languageConfig[this.state.default_lang].zip_code}
                                  onChange={this.handleChange}
                                  style={{borderColor:this.state.zipcodeError}}
                                  name="zipcode"
                                  autoComplete="off"
                                />
                              </FormGroup>
                            </FormGroup>
                          </Col>
                      }
                    </Row>
                  </Col>
                      
                  {(enabled.country == '0') &&
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <FormGroup controlId="country">
                            <ControlLabel>{languageConfig[this.state.default_lang].country} <span style={{color:"red"}}>{this.state.required.country== '0' ? '*':''}</span></ControlLabel>
                            <FormControl
                              type="text"
                              value={(this.state.country) ? this.state.country : ''}
                              placeholder={languageConfig[this.state.default_lang].country}
                              onChange={this.handleChange}
                              name="country"
                              autoComplete="off"
                              style={{borderColor:this.state.countryError}}
                            />
                          </FormGroup>
                        </FormGroup>
                      </Col>
                  }
                  {(enabled.state == '0') &&
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <FormGroup controlId="state">
                            <ControlLabel>{languageConfig[this.state.default_lang].state} <span style={{color:"red"}}>{this.state.required.state== '0' ? '*':''}</span></ControlLabel>
                            <FormControl
                              type="text"
                              value={(this.state.state) ? this.state.state : ''}
                              placeholder={languageConfig[this.state.default_lang].state}
                              onChange={this.handleChange}
                              name="state"
                              style={{borderColor:this.state.stateError}}
                              autoComplete="off"
                            />
                          </FormGroup>
                        </FormGroup>
                      </Col>
                  }
                  {(enabled.addCity == '0') &&
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <FormGroup controlId="city">
                            <ControlLabel>{languageConfig[this.state.default_lang].city} <span style={{color:"red"}}>{this.state.required.addCity== '0' ? '*':''}</span></ControlLabel>
                            <FormControl
                              type="text"
                              value={(this.state.addCity) ? this.state.addCity : ''}
                              placeholder={languageConfig[this.state.default_lang].city}
                              onChange={this.handleChange}
                              name="addCity"
                              style={{borderColor:this.state.addCityError}}
                              autoComplete="off"
                            />
                          </FormGroup>
                        </FormGroup>
                      </Col>
                  }
                  {(enabled.city == '0') &&
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <ControlLabel>{languageConfig[this.state.default_lang].subscriber_city}</ControlLabel>
                          <FormControl style={{borderColor:this.state.cityIDError}} componentClass="select" name="cityID" value={this.state.cityID} placeholder="select" onChange={this.handleChange}>
                            <option value="">{languageConfig[this.state.default_lang].choose_region}</option>
                            {(this.state.cityList) &&
                              this.state.cityList.map((data, index) =>
                                (<optgroup key={'hcity'+index} label={data.country}>
                                  {(data.cities) &&
                                    data.cities.map((city, index) => 
                                      <option key={'hcityval'+index} value={city.cityID}>{city.title}</option>
                                    )
                                  }
                                </optgroup>)
                              )
                            }
                          </FormControl>
                        </FormGroup>
                      </Col>
                  }
                </Row> 
              </div>
            </div>
            <div className="panel margin-top">
              <header className="panel-heading">{languageConfig[this.state.default_lang].login_information}</header>
              <div className="panel-body">
                <Row>
                  {(enabled.userName == '0') &&
                      <Col md={4} xs={12}>
                        <FormGroup controlId="username">
                          <ControlLabel>{languageConfig[this.state.default_lang].user_name} <span style={{color:"red"}}>{this.state.required.userName== '0' ? '*':''}</span></ControlLabel>
                          <FormControl
                            type="text"
                            value={this.state.username}
                            placeholder={languageConfig[this.state.default_lang].user_name}
                            onChange={this.handleChange}
                            name="username"
                            autoComplete="off"
                            style={{borderColor:this.state.usernameError}}
                          />
                        </FormGroup>
                      </Col>
                  }
                  {(enabled.email == '0') &&
                      <Col md={4} xs={12}>
                        <ControlLabel>{languageConfig[this.state.default_lang].email} <span style={{color:"red"}}>{this.state.required.email== '0' ? '*':''}</span></ControlLabel>
                        <FormGroup controlId="email" validationState={this.getValidationEmailState()}>
                           
                          <FormControl
                            type="text"
                            value={this.state.email}
                            placeholder={languageConfig[this.state.default_lang].email}
                            onChange={this.handleChange}
                            name="email"
                            autoComplete="off"
                            style={{borderColor:this.state.emailError}}
                          />
                        </FormGroup>
                      </Col>
                  }
                  {(enabled.confirm_email == '0') &&
                      <Col md={4} xs={12}>
                        <ControlLabel>{languageConfig[this.state.default_lang].confirm_email} <span style={{color:"red"}}>{this.state.required.confirm_email== '0' ? '*':''}</span></ControlLabel>
                        <FormGroup controlId="cemail"  validationState={this.getValidationEmailState2()}>
                          
                          <FormControl
                            type="text"
                            value={this.state.cemail}
                            placeholder={languageConfig[this.state.default_lang].confirm_email}
                            onChange={this.handleChange}
                            name="cemail"
                            autoComplete="off"
                            style={{borderColor:this.state.cemailError}}
                          />
                        </FormGroup>
                      </Col>
                  }
                </Row>
                <Row>
                  {(enabled.password == '0') &&
                      <Col md={4} xs={12}>
                        <FormGroup controlId="password">
                          <ControlLabel>{languageConfig[this.state.default_lang].password} <span style={{color:"red"}}>{this.state.required.password== '0' ? '*':''}</span></ControlLabel>
                          <FormControl
                            type="password"
                            value={this.state.password}
                            placeholder={languageConfig[this.state.default_lang].password}
                            onChange={this.handleChange}
                            name="password"
                            autoComplete="off"
                            style={{borderColor:this.state.passwordError}}
                          />
                          {/* <PasswordStrengthBar password={this.state.password} /> */}
                          <PasswordChecklist
				rules={["minLength","specialChar","number","capital","match"]}
				minLength={8}
				value={this.state.password}
				valueAgain={this.state.cpassword}
				
			/>
                          {/* <div className="alert alert-info" style={{margin: "5px 0px 0px"}}>
 <h5>Password must contain the following:</h5>
  <p id="letter" class="invalid">A <b>lowercase</b> letter</p>
  <p id="capital" class="invalid">A <b>capital (uppercase)</b> letter</p>
  <p id="number" class="invalid">A <b>number</b></p>
     <p id="length" class="invalid">A <b>special character.</b></p>
  <p id="length" class="invalid">Minimum <b>8 characters</b></p>

                         
                         </div> */}
                        </FormGroup>
                      </Col>
                  }
                  {(enabled.confirm_password == '0') &&
                        <Col md={4} xs={12}>
                          <FormGroup controlId="cpassword">
                            <ControlLabel>{languageConfig[this.state.default_lang].confirm_password}<span style={{color:"red"}}>{this.state.required.cpassword== '0' ? '*':''}</span></ControlLabel>
                            <FormControl
                              type="password"
                              value={this.state.cpassword}
                              placeholder={languageConfig[this.state.default_lang].confirm_password}
                              onChange={this.handleChange}
                              name="cpassword"
                              autoComplete="off"
                              style={{borderColor:this.state.cpasswordError}}
                            />
                          </FormGroup>

                        </Col>
                  }

                  {(this.state.charityOption == 'enable' && enabled.enableCharityRegistration == '0') &&
                        <Col md={4} xs={4} className="charity-dropdown">
                          <ControlLabel>Charity:</ControlLabel>
                          <br/>
                          <ReactAutocomplete
                            inputProps={{
                              style: {
                                borderColor: this.state.userEmailError,
                                height: '34px',
                                width: '100%',
                                display: 'block',
                                padding: '6px 12px',
                                border: '1px solid #ccc'
                              }
                            }}
                            items={(this.state.charity) ? this.state.charity : []}
                            shouldItemRender={(item, value) =>
                              item.charity_name
                                .toLowerCase()
                                .indexOf(value.toLowerCase()) > -1
                            }
                            getItemValue={item => item.charity_name}
                            renderItem={(item, highlighted) => (
                              <div
                                className="form-group"
                                key={item.charity_id}
                                data-key={item.charity_id}
                                style={{
                                  backgroundColor: highlighted
                                    ? '#eee'
                                    : 'transparent'
                                }}
                              >
                                {item.charity_name}
                              </div>
                            )}
                            value={this.state.charity_name}
                            onChange={this.onChangeCharity}
                            onSelect={(charity_name, item) => this.setState({ charity_name, charity_id: item.charity_id })}
                          />
                        </Col>
                  }
                </Row>
                    
              </div>
            </div>
            {!hidecapta &&
              <Row>
                <Col md={12} xs={12}>
                  <Recaptcha
                    sitekey={this.props.captchaKey ? this.props.captchaKey : appConfig.reCaptcha.siteKey}
                    render="explicit"
                    hl = {cookies.get('default_lang')}
                    verifyCallback={this.verifyCallback}
                    onloadCallback={this.onloadCallback}
                    expiredCallback={this.expiredCallback}
                  />
                </Col>
              </Row>
            }
            <Row>
              <Col md={12} xs={12}>
                <Checkbox name="term_condition" checked={this.state.term_condition} onChange={this.handleTermConditionChange}>
                  {reg_term.replace('siteName', this.state.siteName)}
                </Checkbox>
              </Col>
              <Col md={12} xs={12}>
                <Button 
                  bsStyle="success" 
                  style={{backgroundColor: (this.state.hover && this.state.hoverID == 'register') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                  data-id = {'register'}
                  onMouseEnter={this.hoverOn} 
                  onMouseLeave={this.hoverOff} 
                  type="submit" 
                  disabled={this.state.disabled}
                >{languageConfig[this.state.default_lang].create_account}</Button>
              </Col>
                  
            </Row>
          </div>
        </form>
      </div>
    );
  }
}


Register.propTypes = {
  register: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  error: state.frontReducer.error,
  regStatus: state.frontReducer.regStatus,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  permission: state.frontReducer.becomePermission,
  getCharity: state.frontReducer.getCharity,
  cityList: state.frontReducer.cityList
});


export default compose(
  connect(mapStateToProps, {register, renderAlert, clearAlert, partnerPermission, getcharityList, getSiteCity})
)(Register);


// WEBPACK FOOTER //
// ./src/app/views/frontend/user/Register.js